export interface FormData {
    businessInfo: BusinessInfo;
    facilities: Facility[];
    shippingInfo: ShippingInfo;
    billingInfo: BillingInfo;
    contactInfo: ContactInfo;
    [key: string]: BusinessInfo | Facility[] | ShippingInfo | BillingInfo | ContactInfo;
}
export interface Facility {
    businessInfo: BusinessInfo;
    shippingInfo: ShippingInfo;
    billingInfo: BillingInfo;
    contactInfo: ContactInfo;
    parentId?: number | null;
}
export interface BusinessInfo {
    facilityName: string;
    address: string;
    address2?: string;
    city: string;
    state: string;
    zip:string;
    phone: string;
    businessType: BusinessType;
    otherBusinessType?: string;
    isCorporate: boolean;
}

export interface BusinessType {
    id: number;
    name: string;
}

export interface DropdownOption {
    value: number;
    label: string;
}

export interface ShippingInfo {
    address: string;
    address2?: string;
    city: string;
    state: string;
    zip:string;
    sameAsBusiness?: boolean;
    deliveryOption?: {
        id: number;
        name: string;
    };
    deliveryOptionOther?: string;
    contact: ContactType;
}

export interface BillingInfo {
    sameAsCorporate: boolean;
    sameAsShipping: boolean;
    address: string;
    address2?: string;
    city: string;
    state: string;
    zip:string;
    contact: ContactType;
    billingTrack?: { id: number; name: string } | null;
    isProRate?: boolean | null;
    isTaxExempt?: boolean;
    taxExemptFile?: File;
}

export interface ContactInfo {
    contacts: ContactType[];
}
export interface AddressType {
    address: string;
    address2?: string;
    city: string;
    state: string;
    zip:string;
}
export interface SmartyAddress {
    city: string;
    entries: number;
    formattedStreet_line: string;
    secondary: string;
    state: string;
    street_line: string;
    zipcode: string;
}
export interface SmartyResponse {
    suggestions: SmartyAddress[];
}
export interface ContactType {
    firstName: string;  
    lastName: string;            
    phone: string;
    ext: string;
    email: string;
    preferredMethod: 'phone' | 'email';
    title?: string;
    contactType?: string;
    sameAsPrimary?: boolean;
}

 export const deliveryOptions = [
    { value: 1, label: 'Front Door' },
    { value: 2, label: 'Mailroom' },
    { value: 3, label: 'Front Desk' },
    { value: 4, label: 'Loading Doc' },
    { value: 5, label: 'Other' },
];
export const contactTypes = {
    Primary: { label: 'Primary Contact', type: 'Primary' },
    Shipping: { label: '', type: 'Shipping' },
    Billing: { label: '', type: 'Billing' },
    Purchasing: { label: 'Purchasing Department', type: 'Purchasing' },
    AccountsPayable: { label: 'Accounts Payable', type: 'Accounts Payable' },
    Facility: {label: 'Facility', type:'Facility'}
} as const;